import { ClipboardCheck, Target, Dumbbell, Compass, Home, Apple } from "lucide-react";

const TreatmentSection = () => {
  const steps = [
    {
      number: 1,
      icon: ClipboardCheck,
      title: "Clinical Assessment",
      description: "Gap measurement & core stability evaluation to understand your specific condition.",
    },
    {
      number: 2,
      icon: Compass,
      title: "Posture Function Analysis",
      description: "Comprehensive evaluation of spinal alignment and functional movement patterns.",
    },
    {
      number: 3,
      icon: Target,
      title: "Targeted Core Activation",
      description: "Deep transverse abdominis muscle activation using proven techniques.",
    },
    {
      number: 4,
      icon: Dumbbell,
      title: "Strength Training",
      description: "Safe & guided strengthening plan customized to your recovery stage.",
    },
    {
      number: 5,
      icon: Apple,
      title: "Nutrition",
      description: "Dietary guidance to support tissue repair and overall postpartum health.",
    },
    {
      number: 6,
      icon: Home,
      title: "Lifestyle and Home Guidance",
      description: "Complete recovery roadmap with safe movements for daily activities.",
    },
  ];

  return (
    <section id="treatment" className="section-spacing bg-white" data-testid="treatment-section">
      <div className="section-container">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block bg-pink-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            Our Specialized Approach
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-testid="treatment-headline">
            How We Treat Diastasis Recti
          </h2>
          <p className="text-lg text-stone-600">
            Unlike generic gym workouts, we follow a structured <strong className="text-blue-700">rehabilitation protocol</strong> designed specifically for postpartum recovery.
          </p>
        </div>

        {/* Steps Timeline */}
        <div className="relative max-w-4xl mx-auto">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className="relative flex gap-6 mb-12 last:mb-0"
              data-testid={`treatment-step-${step.number}`}
            >
              {/* Timeline */}
              <div className="relative flex flex-col items-center">
                <div className="step-number">
                  {step.number}
                </div>
                {index < steps.length - 1 && (
                  <div className="w-0.5 bg-gradient-to-b from-blue-600 to-pink-200 flex-grow mt-4"></div>
                )}
              </div>

              {/* Content Card */}
              <div className="flex-grow pb-8">
                <div className="card-feature group hover:bg-pink-50/50">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-blue-200 transition-colors">
                      <step.icon className="text-blue-700" size={24} />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-blue-900 mb-2">{step.title}</h3>
                      <p className="text-stone-600">{step.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="text-center mt-12 bg-gradient-to-r from-pink-50 to-blue-50 rounded-2xl p-8 max-w-3xl mx-auto" data-testid="treatment-note">
          <p className="text-stone-700">
            Each treatment plan is <strong className="text-blue-700">personalized</strong> based on your assessment results, ensuring safe and effective recovery.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TreatmentSection;
